/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import * as React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/material";
import { UserEnrolmentForm } from "../../components/userEnrolmentForm/userEnrolmentForm";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import "./userEnrolment.scss";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { StyledTableCell, StyledTableCellFooter, StyledTableCellHead, StyledTableCellMail, StyledTableCellRole, StyledTableCellTrialDays } from "./userEnrolmentCommanStyle";

export const UserEnrolmentTable: React.FC<any> = () => {
  const navigate = useNavigate();
  const [backButtonChange, setBackButtonChange] = React.useState(false);
  const [showTeam, setShowTeam] = React.useState(false);

  return (
    <>
      <div className="userEnrolmentParent">
        <div className={!backButtonChange ? "backButton" : "forwardButton"}>
          <span
            className="backButtonName"
            onClick={() => {
              navigate("/users");
            }}
          >
            {!backButtonChange && <ArrowBackIosNewIcon fontSize="small" />}User
            Management{" "}
            {backButtonChange && <ArrowForwardIosIcon fontSize="small" />}
          </span>
        </div>
        <Box className="userEnrolmentTable">
          <Box sx={{display: 'flex', alignItems: 'center'}} mb={2}>
            <div className="helpText">Create Multiple Accounts</div>
          </Box>
          <Box className="tableBox">
            <div>
              <Table className="tableHeader" aria-label="simple table">
                <TableHead>
                  <TableRow sx={{ display: 'flex' }} >
                    <StyledTableCellHead className="tableRowCount"></StyledTableCellHead>
                    <StyledTableCell className="tableRow" >
                      Company name*
                    </StyledTableCell>
                    <StyledTableCell className="tableRow" >
                      First name*
                    </StyledTableCell>
                    <StyledTableCell className="tableRow" >
                      Last name*
                    </StyledTableCell>
                    <StyledTableCellMail className="tableRow" >
                      Company email*
                    </StyledTableCellMail>
                    <StyledTableCellRole className="tableRow" >
                      Role*
                    </StyledTableCellRole>
                    <StyledTableCellTrialDays className="tableRow" >
                      Trial / Expiry
                    </StyledTableCellTrialDays>
                    <StyledTableCell className="tableRow">
                      Team {showTeam ? '*' : ''}
                    </StyledTableCell>
                    <StyledTableCellRole className="tableRow" >
                      MFA / 2FA
                    </StyledTableCellRole>
                    <StyledTableCellFooter className="tableRowButton"></StyledTableCellFooter>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
            <div >
              <Table className="tableBoday">
                <TableHead>
                  <TableRow>
                    <div className="tableRowHight">
                      <UserEnrolmentForm
                        backButtonChange={setBackButtonChange}
                        callback={(value: boolean) => setShowTeam(value)}
                      />
                    </div>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
          </Box>
        </Box>
      </div>
    </>
  );
};
